"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Anchor = void 0;
var Anchor = exports.Anchor = /*#__PURE__*/function (Anchor) {
  Anchor[Anchor["CENTER"] = 0] = "CENTER";
  Anchor[Anchor["TOP_LEFT"] = 1] = "TOP_LEFT";
  Anchor[Anchor["TOP_RIGHT"] = 2] = "TOP_RIGHT";
  Anchor[Anchor["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
  Anchor[Anchor["BOTTOM_RIGHT"] = 4] = "BOTTOM_RIGHT";
  return Anchor;
}({});
//# sourceMappingURL=Anchor.js.map